import { httpService } from "./httpService";

export const referralService = {
  async list() {
    try {
      const referralsListResp = await httpService.getRequest<any>("referrals");
      const referrals = referralsListResp;      
      return referrals;
    } catch (error) {
      console.error("Error fetching referral list:", error);
    }
  },
};